<template>
  <g>
    <border />
    <text x="50%" y="50%" text-anchor="middle" stroke="#586E82" style="font-weight: 300" dy=".3em">
      {{ name.replace(/key_/gi, '') }}
    </text>
  </g>
</template>

<script>
  import Border from './_border';
  export default {
    components: {
      Border
    },

    props: {
      name: {
        type: [String],
        default: ''
      }
    }
  };
</script>
